var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {
      staticClass: "xx-re-text",
      domProps: { innerHTML: _vm._s(_vm.brMag(_vm.message.content)) }
    }),
    _vm._v(" "),
    _vm.message.title
      ? _c("div", { staticClass: "xx-hc-box" }, [
          _c("div", { staticClass: "xx-hc-title" }, [
            _vm._v(_vm._s(_vm.message.title))
          ]),
          _vm._v(" "),
          !_vm.message.tag
            ? _c(
                "div",
                { staticClass: "xx-hc-btn" },
                [
                  _vm.message.yesTag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.handlePost(1, _vm.message.yesTag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.message.yesTag))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.message.noTag
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "warning", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.handlePost(2, _vm.message.noTag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.message.noTag))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c("div", { staticClass: "xx-hc-xz" }, [
                _vm._v("\n      您的选择："),
                _c("span", { staticClass: "xx-hc-xz-xz" }, [
                  _vm._v(_vm._s(_vm.message.tag))
                ])
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "xx-hc-content",
      domProps: { innerHTML: _vm._s(_vm.replaceRemark(_vm.message.remark)) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bd0cec9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bd0cec9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Message.vue
// module id = null
// module chunks = 